import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { Text, Box, Flex, Button, VectorRightIcon } from 'uikit'
import { useTranslation } from 'contexts/Localization'

const Model = styled.img`
  width: 200px;

  ${({ theme }) => theme.mediaQueries['2sm']} {
    width: 300px;
  }
`

const PurpleTitle = styled(Text)`
  font-size: 18px;

  ${({ theme }) => theme.mediaQueries.xl} {
    font-size: 20px;
  }
`

const Title = styled(Text)`
  font-size: 25px;

  ${({ theme }) => theme.mediaQueries['2sm']} {
    font-size: 30px;
  }

  ${({ theme }) => theme.mediaQueries.md} {
    font-size: 35px;
  }

  ${({ theme }) => theme.mediaQueries.xl} {
    font-size: 40px;
  }
`

const Detail = styled(Text)`
  font-size: 14px;

  ${({ theme }) => theme.mediaQueries['2sm']} {
    font-size: 16px;
  }
`

const Quality: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Box maxWidth="1120px" mx="auto" mt={['100px', null, null, null, '230px']} px={['30px', null, '54px']}>
      <PurpleTitle color="primary" fontWeight="600" textAlign="center">
        ERC20
      </PurpleTitle>
      <Title fontWeight="600" textAlign="center">
        {t('Dark Matter DeFi Token')}
      </Title>
      <Flex
        mt={['50px', null, null, '60px']}
        justifyContent="space-around"
        mx="auto"
        alignItems="center"
        flexDirection={['column', null, null, null, null, 'row']}
      >
        <Model src="/images/home/token-model.png" alt="token-model" />
        <Flex flexDirection="column" alignItems="start" mt={['35px', null, null, null, null, '0']}>
          <Detail fontWeight="300" color="textSecondary" maxWidth={['100%', null, null, null, null, '500px']}>
            {t(
              '(DMD) is the native project token for the Dark Matter DeFi ecosystem. Additionally, DMD can be used to purchase NFTs on the Opera House Marketplace, feed Fantomons, bet in Weaponized Countries, and much more!',
            )}
          </Detail>
          <Button
            as="a"
            href="https://docs.darkmatterdefi.com/introduction/darkmatter-dmd-tokenomics"
            target="_blank"
            height="27px"
            mt="32px"
            variant="text"
            p="0"
            endIcon={<VectorRightIcon fill="#128DFF" />}
          >
            <Text fontSize="18px" fontWeight="500" color="#128DFF">
              {t('Learn more about DMD')}
            </Text>
          </Button>
          <Button
            as={Link}
            to="/swap?outputCurrency=0x90e892fed501ae00596448aecf998c88816e5c0f"
            height="27px"
            mt="14px"
            variant="text"
            p="0"
            endIcon={<VectorRightIcon />}
          >
            <Text fontSize="18px" fontWeight="500">
              {t('Buy DMD')}
            </Text>
          </Button>
        </Flex>
      </Flex>
    </Box>
  )
}

export default Quality
